import {
    REQUEST_REF_MAPS,
    RECEIVE_REF_MAPS,
    RECEIVE_REF_MAPS_ERROR,
    RESET_REF_MAPS,
} from '../actions/discountServiceTypes.js';

const EMPTY = { toCds: {}, toLegacy: {}, unkeyed: 0, total: 0 };

export const initState = {
    fetching: false,
    fetched: false,
    error: null,
    /**
     * `{products, facilities, devices, users}`, each `{toCds, toLegacy, unkeyed, total}`, plus
     * `userGroups: {members, total}` mapping a group id to its `merchant_user.id`s.
     * `unkeyed` counts core-api rows with no legacy key — those cannot be targeted from the
     * portal at all, so the number has to stay visible rather than being silently dropped.
     */
    maps: {
        products: EMPTY,
        facilities: EMPTY,
        devices: EMPTY,
        users: { ...EMPTY, ambiguous: [] },
        userGroups: { members: {}, total: 0 },
    },
    groupId: null,
    lastUpdated: null,
};

export default function refMaps(state = initState, action) {
    switch (action.type) {
        case REQUEST_REF_MAPS:
            return { ...state, fetching: true, fetched: false, error: null };
        case RECEIVE_REF_MAPS:
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: null,
                maps: action.maps,
                groupId: action.groupId,
                lastUpdated: action.receivedAt,
            };
        case RECEIVE_REF_MAPS_ERROR:
            console.error(action.error);
            return {
                ...state,
                fetching: false,
                fetched: false,
                error: action.error.toString(),
                maps: initState.maps,
            };
        case RESET_REF_MAPS:
            return { ...initState };
        default:
            return state;
    }
}
